import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-leftArrow",
  "use": "icon-leftArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-leftArrow\"><path d=\"M655.82102258 262.11097308v499.77805384c0 19.77539063-12.58433942 25.16867883-28.76420405 12.58433941l-323.59730121-249.88902691c-8.9888142-7.19105121-8.9888142-19.77539063 1e-8-26.96644184l323.5973012-249.88902691c16.17986541-10.78657642 28.76420483-5.3932882 28.76420406 14.38210241z\" p-id=\"7354\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol